import { render, staticRenderFns } from "./BoardNavSummarize.vue?vue&type=template&id=ecaf0e5c&scoped=true&"
import script from "./BoardNavSummarize.vue?vue&type=script&lang=js&"
export * from "./BoardNavSummarize.vue?vue&type=script&lang=js&"
import style0 from "./BoardNavSummarize.vue?vue&type=style&index=0&id=ecaf0e5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecaf0e5c",
  null
  
)

export default component.exports